/**
 * Charcoal-cube brand mark assets for management app / player chrome.
 *
 * @see packages/shared/assets/README.md
 * @see docs/brand/BRAND-KIT.md
 */

/** PWA / browser `theme-color` — near-black night canvas (#0D0D18). */
export const LUCIMARK_BRAND_THEME_COLOR = '#0D0D18'

/** Orange mid / deep — aligned with `tokens.css` `--brand-orange*` and email CTAs. */
export const LUCIMARK_BRAND_ORANGE = '#FF7A1A'
export const LUCIMARK_BRAND_ORANGE_DEEP = '#C2410C'

/** Hosted PNG lockup for transactional email headers (see `scripts/sync-brand-social-assets.mjs`). */
export const LUCIMARK_EMAIL_LOCKUP_SOURCE_WIDTH = 480
export const LUCIMARK_EMAIL_LOCKUP_SOURCE_HEIGHT = 156
/** Display size in HTML (half of source for retina). */
export const LUCIMARK_EMAIL_LOCKUP_DISPLAY_WIDTH = 240
export const LUCIMARK_EMAIL_LOCKUP_DISPLAY_HEIGHT = 78
/** Bump when `lucimark-lockup-email.png` changes so clients refetch after CDN upload. */
export const LUCIMARK_EMAIL_LOCKUP_ASSET_VERSION = '20260707'
export const LUCIMARK_EMAIL_LOCKUP_URL = `https://cdn.lucimark.com/img/lucimark-lockup-email.png?v=${LUCIMARK_EMAIL_LOCKUP_ASSET_VERSION}`

/** Open Graph / Twitter large-card image (1200×630). */
export const LUCIMARK_OG_IMAGE_URL = 'https://cdn.lucimark.com/img/og-image.png'
export const LUCIMARK_OG_IMAGE_WIDTH = 1200
export const LUCIMARK_OG_IMAGE_HEIGHT = 630
export const LUCIMARK_BRAND_MARK_MODULE_PATHS = {
  light: '@lucimark/shared-assets/img/lucimark-mark.svg',
  dark: '@lucimark/shared-assets/img/lucimark-mark-dark.svg'
} as const

export const LUCIMARK_BRAND_LOCKUP_MODULE_PATHS = {
  light: '@lucimark/shared-assets/img/lucimark-lockup.svg',
  dark: '@lucimark/shared-assets/img/lucimark-lockup-dark.svg'
} as const

/** Tight header crops (marketing mastheads). Prefer these over the full lockup in fixed bars. */
export const LUCIMARK_BRAND_LOCKUP_HEADER_MODULE_PATHS = {
  light: '@lucimark/shared-assets/img/lucimark-lockup-header-light.svg',
  dark: '@lucimark/shared-assets/img/lucimark-lockup-header.svg'
} as const

export const LUCIMARK_BRAND_MARK_MONO_MODULE_PATH = '@lucimark/shared-assets/img/lucimark-mark-mono.svg'

export const LUCIMARK_PLAYER_SPLASH_MODULE_PATHS = {
  static: '@lucimark/shared-assets/img/player-splash.svg',
  animated: '@lucimark/shared-assets/img/player-splash-animated.svg'
} as const

/** Default idle / waiting chrome on `#161310` (dark lockup). */
export const LUCIMARK_PLAYER_IDLE_LOCKUP_MODULE_PATH
  = '@lucimark/shared-assets/img/lucimark-lockup-dark.svg'

export type LucimarkBrandMarkScheme = 'light' | 'dark'

export interface LucimarkBrandMarkImports {
  light: string
  dark: string
}

export function resolveLucimarkBrandMarkSrc(
  scheme: LucimarkBrandMarkScheme,
  imports: LucimarkBrandMarkImports
): string {
  return scheme === 'light' ? imports.light : imports.dark
}

export function resolveLucimarkBrandLockupSrc(
  scheme: LucimarkBrandMarkScheme,
  imports: LucimarkBrandMarkImports
): string {
  return resolveLucimarkBrandMarkSrc(scheme, imports)
}
